import { FunctionComponent } from "react";
import { BottomSheet, IconButton } from "@ppb/the-wall-web";
import { SystemIconName } from "@ppb/the-wall-icons/types";
import styles from "./HeaderDepositBottomSheet.web.css";
import { useDepositBottomSheet } from "./useDepositBottomSheet.web";

type HeaderDepositBottomSheetProps = {
  depositButtonLabel: string;
  depositBottomSheetLabel: string;
  depositUrl?: string;
  onDepositButtonClick?: () => void;
  onDepositBottomSheetClose?: () => void;
};

/**
 * Renders the Header's deposit button and, once opened, its bottom sheet with the (cross-origin)
 * deposit iframe. Owns its own open/height state via {@link useDepositBottomSheet}.
 */
export const HeaderDepositBottomSheet: FunctionComponent<HeaderDepositBottomSheetProps> = ({
  depositButtonLabel,
  depositBottomSheetLabel,
  depositUrl = "",
  onDepositButtonClick,
  onDepositBottomSheetClose,
}) => {
  const { isDepositOpen, depositContentHeight, openDeposit, closeDeposit } = useDepositBottomSheet(depositUrl);

  const handleDepositButtonClick = (): void => {
    onDepositButtonClick?.();
    openDeposit();
  };

  const handleDepositBottomSheetClose = (): void => {
    onDepositBottomSheetClose?.();
    closeDeposit();
  };

  return (
    <div className={styles.depositButtonContainer}>
      <IconButton icon={SystemIconName.DEPOSIT} text={depositButtonLabel} onPress={handleDepositButtonClick} />

      {isDepositOpen && (
        <BottomSheet title={depositBottomSheetLabel} onHeaderIconTap={handleDepositBottomSheetClose}>
          <div className={styles.depositBottomSheet}>
            <div className={styles.depositBottomSheetContent} style={{ height: `${depositContentHeight}px` }}>
              <iframe src={depositUrl} title={depositBottomSheetLabel} className={styles.depositIframe} />
            </div>
          </div>
        </BottomSheet>
      )}
    </div>
  );
};
